import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { registerAccessTokenProvider } from "@/helpers/axiosInstance";

/**
 * Hands the Auth0 SDK's token getter to axiosInstance so authenticated requests
 * (the admin routes behind the server's AdminGuard) always carry a fresh access token.
 * Renders nothing; must sit inside Auth0Provider.
 */
const AuthTokenBridge = () => {
    const { isAuthenticated, getAccessTokenSilently } = useAuth0();

    useEffect(() => {
        registerAccessTokenProvider(isAuthenticated ? () => getAccessTokenSilently() : null);
        return () => registerAccessTokenProvider(null);
    }, [isAuthenticated, getAccessTokenSilently]);

    return null;
};

export default AuthTokenBridge;
